function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 24a8 8 0 110-16 8 8 0 010 16z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.699 19.261l4.819-4.82a.962.962 0 00-1.359-1.36l-4.14 4.14-2.178-2.178a.962.962 0 00-1.36 1.36l2.858 2.858a.957.957 0 001.36 0z",
  fill: "#fff"
});

var SvgIconDone = function SvgIconDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    color: "#2DB35C"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgY29sb3I9IiMyREIzNUMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNiAyNEMxMS41ODE2IDI0IDggMjAuNDE4NCA4IDE2QzggMTEuNTgxNiAxMS41ODE2IDggMTYgOEMyMC40MTg0IDggMjQgMTEuNTgxNiAyNCAxNkMyNCAyMC40MTg0IDIwLjQxODQgMjQgMTYgMjRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTE1LjY5ODkgMTkuMjYxMUwyMC41MTc5IDE0LjQ0MDVDMjAuODk0OCAxNC4wNjUgMjAuODkzOCAxMy40NTY1IDIwLjUxNzkgMTMuMDgxQzIwLjE0MzQgMTIuNzA2MSAxOS41MzM5IDEyLjcwNjEgMTkuMTU5IDEzLjA4MUwxNS4wMTkyIDE3LjIyMTlMMTIuODQxMiAxNS4wNDMzQzEyLjQ2NTggMTQuNjY4MyAxMS44NTY3IDE0LjY2ODMgMTEuNDgxOCAxNS4wNDMzQzExLjEwNjMgMTUuNDE4NyAxMS4xMDYzIDE2LjAyODMgMTEuNDgxOCAxNi40MDI4TDE0LjMzOTUgMTkuMjYxMUMxNC41Mjc1IDE5LjQ0OTEgMTQuNzczMSAxOS41NDI4IDE1LjAxOTIgMTkuNTQyOEMxNS4yNjUzIDE5LjU0MjggMTUuNTExIDE5LjQ0OTEgMTUuNjk4OSAxOS4yNjExWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgIconDone as ReactComponent };